<template>
    <!-- Error page-->
    <div class="misc-wrapper">
        <b-link class="brand-logo">
            <b-img
                id="top-bar-logo"
                center
                src="https://mfe.saysimple.io/static/images/logos/saysimple-logo-dark2.png"
            />
        </b-link>

        <div class="misc-inner p-2 p-sm-3">
            <div class="w-100 text-center">
                <h2 class="mb-1">{{ $t("page-not-found") }}</h2>
                <p class="mb-2">{{ $t("requested-url-not-found") }}</p>

                <b-button :to="{ path: '/' }" class="mb-2 btn-sm-block" variant="primary">
                    {{ $t("back-to-home") }}
                </b-button>

                <b-img :src="imgUrl" alt="Error page" fluid />
            </div>
        </div>
    </div>
    <!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import { BButton, BImg, BLink } from "bootstrap-vue";
import store from "@/store/index";

export default {
    components: {
        BLink,
        BButton,
        BImg,
    },
    data() {
        return {
            downImg: require("@/assets/images/pages/error.svg"),
        };
    },
    computed: {
        imgUrl() {
            if (store.state.appConfig.layout.skin === "dark") {
                this.downImg = require("@/assets/images/pages/error-dark.svg");
                return this.downImg;
            }
            return this.downImg;
        },
    },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";
</style>
